import { useSelector } from "react-redux";

function UpcomingMeetings({ meetings, onUpdate }) {
    const user = useSelector(state => state.profil);

    const joinMeeting = (meeting) => {
        const now = Date.now();
        const meetingTime = new Date(meeting.scheduledAt).getTime();

        console.log(now);
        console.log(meetingTime);

        if (now < meetingTime) {
            alert("La réunion n'a pas encore commencé");
            return;
        }

        window.open(meeting.meetingLink, "_blank");
    };

    const cancelMeeting = async (id) => {
        const token = sessionStorage.getItem("token");

        await fetch(`${process.env.REACT_APP_API_URL}/meeting/cancel`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ meetingId: id })
        });

        onUpdate();
    };

    const finishMeeting = async (id) => {
        const token = sessionStorage.getItem("token");

        await fetch(`${process.env.REACT_APP_API_URL}/meeting/finish`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ meetingId: id })
        });

        onUpdate();
    };

    const now = new Date();

    return (
        <div className="block">
            <h2>Mes réunions</h2>

            {meetings.map(m => {
                const isStarted = now >= new Date(m.scheduledAt);
                const isOwner = m.owner === user._id;

                return (
                    <div key={m._id} className="card">

                        <p>{m.description}</p>
                        <p>{new Date(m.scheduledAt).toLocaleString()}</p>

                        <div className="panel">
                            <button className="btn-blue" onClick={() => joinMeeting(m)}>
                                Rejoindre
                            </button>

                            {/* 👇 seulement si owner */}
                            {isOwner && (
                                <div className="actions">
                                    {isStarted ? (
                                        <button
                                            className="btn-finish"
                                            onClick={() => finishMeeting(m._id)}
                                        >
                                            Terminer
                                        </button>
                                    ) : (
                                        <button
                                            className="btn-cancel"
                                            onClick={() => cancelMeeting(m._id)}
                                        >
                                            Annuler
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}

        </div>
    );
}

export default UpcomingMeetings;